import store from '@/store/store'
import {ref, computed} from "vue";
const precededPopup = computed(() => store.getters["settingsPopup/getPrecededPopup"]);
const currentPopup = computed(() => store.getters["settingsPopup/getCurrentPopup"]);

export function useFieldMedia(){
  const popupOpenedBy = ref('');
  const popupActive = ref(false);
  const isPopupMediaContentActive = computed(() => store.getters['mediaContent/isMediaContentActive']);
  const isPopupMediaActive = computed(() => isPopupMediaContentActive.value || popupActive.value);

  async function popupMediaOpen(event, fieldName = ''){
    popupOpenedBy.value = fieldName;
    if(currentPopup.value){
      await store.dispatch("settingsPopup/popupPrecededChange", currentPopup.value);
    }
    popupActive.value = true;
    await store.dispatch("settingsPopup/mediaChoosingToggle", true);
  }
  async function popupMediaClose(){
    popupActive.value = false;
    popupOpenedBy.value = '';
    if(precededPopup.value){
      await store.dispatch("settingsPopup/popupChange", precededPopup.value.popup);
      await store.dispatch("settingsPopup/popupPrecededChange", null);
    }
    await store.dispatch("settingsPopup/mediaChoosingToggle", false);
    await store.dispatch('mediaContent/mediaContentToggle', false);
  }

  return {
    isPopupMediaActive,
    popupOpenedBy,
    popupMediaOpen,
    popupMediaClose,
  }
}